import { FunctionComponent } from 'react';
import { Ticket } from '@wix/answers-api';
import { useTranslation } from '@wix/wix-i18n-config';
import { Box, Text } from '@wix/design-system';
import { DATA_HOOKS } from '../../../dataHooks';
import { RenderHTML } from '@wix/cc-user-facing-common-components';
import { ClockIcon } from '../../../icons/ClockIcon';
import css from './index.module.scss';

type TicketOverYearProps = {
  ticket: Ticket;
};

export const TicketOverYear: FunctionComponent<TicketOverYearProps> = ({
  ticket,
}: TicketOverYearProps) => {
  const { t } = useTranslation();
  const isTicketOverYear =
    new Date().getTime() - ticket.creationDate > 31556926000;

  return isTicketOverYear ? (
    <Box className={css.ticketOverYearMessageWrapper}>
      <Box className={css.ticketOverYearIcon} verticalAlign="middle">
        <ClockIcon />
      </Box>
      <Box className={css.ticketOverYearText}>
        <Text size="small">
          <RenderHTML
            dataHook={DATA_HOOKS.TICKET_OVER_YEAR_MESSAGE}
            html={t('ticket.year.old.notice')}
          />
        </Text>
      </Box>
    </Box>
  ) : null;
};
